






















import HeaderLayout from '@/layouts/nested/HeaderLayout.vue';
import { Component } from 'vue-property-decorator';
import Base from '../Base';
import DCPOperatorService from '@/service/DCPOperatorService';
import { DCPConference } from '@/models/DCPConference';

@Component({
	components: { HeaderLayout }
})
export default class DCPConferences extends Base {
	conferences: DCPConference[] = [];

	fields = [
		{
			key: 'moderatorName' as keyof DCPConference,
			label: "Moderator",
			sortable: true
		},
		{
			key: 'title' as keyof DCPConference,
			label: "Titel",
			sortable: true
		},
		{
			key: 'participantPIN' as keyof DCPConference,
			label: "Tn-PIN",
			sortable: true
		},
		{
			key: 'moderatorPIN' as keyof DCPConference,
			label: "Mod-PIN",
			sortable: true
		},
    {
      key: 'action',
      label: this.t('common.action')
    }
	];

	mounted(): void {
		this.getConferences();
	}

	private getConferences() {
		DCPOperatorService.getDCPConferences().then((obj) => {
      this.conferences = obj;
		});
	}

  stopConference(id: string) {
    console.log(id);
    DCPOperatorService.stopDCPConference(id).then(() => {
      this.getConferences();
    });
  }
}
